var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ],
      staticClass: "main-content",
      attrs: {
        "element-loading-text": "Loading...",
        "element-loading-spinner": "el-icon-loading",
        "element-loading-background": "rgba(170,170,170,0.5)"
      }
    },
    [
      _c("div", { staticClass: "section operations" }, [
        _c("div", { staticClass: "triggers" }, [
          _c(
            "div",
            [
              _c("div", { staticClass: "input-label" }, [
                _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Filter")))
              ]),
              _c("el-input", {
                staticStyle: { width: "180px" },
                model: {
                  value: _vm.keyword,
                  callback: function($$v) {
                    _vm.keyword = $$v
                  },
                  expression: "keyword"
                }
              }),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "permission",
                      rawName: "v-permission",
                      value: ["button_AirRoute_add"],
                      expression: "['button_AirRoute_add']"
                    }
                  ],
                  attrs: { type: "primary" },
                  on: { click: _vm.newHandler }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Add")))]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "permission",
                      rawName: "v-permission",
                      value: ["button_AirRoute_edit"],
                      expression: "['button_AirRoute_edit']"
                    }
                  ],
                  attrs: { type: "primary" },
                  on: { click: _vm.editHandler }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Edit")))]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "permission",
                      rawName: "v-permission",
                      value: ["button_AirRoute_delete"],
                      expression: "['button_AirRoute_delete']"
                    }
                  ],
                  attrs: { type: "primary" },
                  on: { click: _vm.delHandler }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Delete")))]
              )
            ],
            1
          )
        ])
      ]),
      _c(
        "div",
        { staticStyle: { "flex-grow": "1", "min-height": "350px" } },
        [
          _c("cargo-ag-grid", {
            staticStyle: { height: "100%" },
            attrs: {
              "grid-options": _vm.gridOptions,
              "column-defs": _vm.columnDefs,
              "row-data": _vm.filteredRowData
            },
            on: {
              gridReady: function(params) {
                _vm.gridApi = params.api
              }
            }
          })
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          staticClass: "route-form",
          attrs: {
            visible: _vm.routeDialog.visible,
            title: _vm.routeDialog.title,
            width: "420px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.routeDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "el-form",
            {
              attrs: {
                "label-width": _vm.$selectByLang("100px", "120px"),
                "label-position": "left"
              }
            },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "lable-blue",
                  attrs: { label: _vm.$t("CargoMsg.Cargo_Code") }
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "150px" },
                    attrs: {
                      placeholder: _vm.$t("CargoMsg.Cargo_MustBEntered")
                    },
                    model: {
                      value: _vm.routeDialog.form.code,
                      callback: function($$v) {
                        _vm.$set(_vm.routeDialog.form, "code", $$v)
                      },
                      expression: "routeDialog.form.code"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lable-blue",
                  attrs: { label: _vm.$t("CargoMsg.Cargo_Name") }
                },
                [
                  _c("el-input", {
                    staticStyle: { width: "150px" },
                    attrs: {
                      placeholder: _vm.$t("CargoMsg.Cargo_MustBEntered")
                    },
                    model: {
                      value: _vm.routeDialog.form.name,
                      callback: function($$v) {
                        _vm.$set(_vm.routeDialog.form, "name", $$v)
                      },
                      expression: "routeDialog.form.name"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("CargoMsg.Cargo_EnglishNamed") } },
                [
                  _c("el-input", {
                    staticStyle: { width: "180px" },
                    attrs: { placeholder: " " },
                    model: {
                      value: _vm.routeDialog.form.englishName,
                      callback: function($$v) {
                        _vm.$set(_vm.routeDialog.form, "englishName", $$v)
                      },
                      expression: "routeDialog.form.englishName"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lable-blue",
                  attrs: { label: _vm.$t("CargoMsg.Cargo_OriginRegionCode") }
                },
                [
                  _c("cargo-advance-select", {
                    staticStyle: { width: "230px" },
                    attrs: {
                      "select-type": _vm.TYPE_NAMES.static_data_AirRegion,
                      cache: false,
                      "static-options": _vm.routeDialog.airRegionList,
                      "show-custom-label-in-option": true,
                      "custom-label": _vm.airRegionLabel,
                      filterable: "",
                      "default-value": _vm.routeDialog.form.originRegionCode,
                      placeholder: _vm.$t("CargoMsg.Cargo_MustBEntered")
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.routeDialog.form.originRegionCode = p.value
                      }
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticClass: "lable-blue",
                  attrs: { label: _vm.$t("CargoMsg.Cargo_TargetRegionCode") }
                },
                [
                  _c("cargo-advance-select", {
                    staticStyle: { width: "230px" },
                    attrs: {
                      "select-type": _vm.TYPE_NAMES.static_data_AirRegion,
                      cache: false,
                      "static-options": _vm.routeDialog.airRegionList,
                      "show-custom-label-in-option": true,
                      "custom-label": _vm.airRegionLabel,
                      filterable: "",
                      "default-value": _vm.routeDialog.form.targetRegionCode,
                      placeholder: _vm.$t("CargoMsg.Cargo_MustBEntered")
                    },
                    on: {
                      parentCallBack: function(p) {
                        _vm.routeDialog.form.targetRegionCode = p.value
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.commitHandler }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Confirm")))]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.routeDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("Message.Cancel")))]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }